<template>
  <section class="page_wrapper">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <h2>Sign up</h2>
          <div class="block">
            <SignUpForm/>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-lg-12 text-center">
          <router-link to="/login">
            Back to log in
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import SignUpForm from "@/components/SignUpForm";
export default {
  name: "SignUp",
  components: {
    SignUpForm
  }
}
</script>

<style scoped>

</style>